import http from '../_http'

const actionLog = {
  //user
  summaryUser: (m) => { return http.get(`manager/log/action/user`, m); },
  listUser: (m) => { return http.post(`manager/log/action/user/list`, m); },
  detailUser: (m) => { return http.get(`manager/log/action/user/${m.id}`); },

  //admin
  summaryAdmin: (m) => { return http.get(`manager/log/action/admin`, m); },
  listAdmin: (m) => { return http.post(`manager/log/action/admin/list`, m); },
  detailAdmin: (m) => { return http.get(`manager/log/action/admin/${m.id}`); },

  //partner
  summaryPartner: (m) => { return http.get(`manager/log/action/partner`, m); },
  listPartner: (m) => { return http.post(`manager/log/action/partner/list`, m); },
  detailPartner: (m) => { return http.get(`manager/log/action/partner/${m.id}`); },
}

export default actionLog

export { actionLog }